// extracted by mini-css-extract-plugin
export default {"downloadContainer":"styles_downloadContainer__cdUvq","collectionContainer":"styles_collectionContainer__AXtCh"};